import { motion } from 'framer-motion';

const benefits = [
  {
    icon: 'ri-flashlight-line',
    title: 'Blitzschnell',
    description: 'Optimierte Ladezeiten unter 2 Sekunden sorgen für zufriedene Besucher und bessere Google-Rankings.'
  },
  {
    icon: 'ri-robot-2-line',
    title: 'AI-gestützt',
    description: 'Modernste AI-Technologie für Chatbots, Automatisierung und intelligente Lösungen, die Ihr Business voranbringen.'
  },
  {
    icon: 'ri-lock-2-line',
    title: 'Sicher & DSGVO-konform',
    description: 'Höchste Sicherheitsstandards mit SSL-Verschlüsselung und vollständiger DSGVO-Konformität für Ihre Webseite.'
  },
  {
    icon: 'ri-gallery-view-2',
    title: 'Modernes Design',
    description: 'Zeitgemäße, ansprechende Designs, die Ihre Marke perfekt repräsentieren und Besucher begeistern.'
  },
  {
    icon: 'ri-user-heart-line',
    title: 'Persönlicher Ansprechpartner',
    description: 'Ich begleite Sie persönlich durch das gesamte Projekt – von der Idee bis zum Launch und darüber hinaus.'
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Laufender Support',
    description: 'Auch nach dem Launch bin ich für Sie da – mit Wartung, Updates und kontinuierlicher Optimierung.'
  }
];

export default function Benefits() {
  return (
    <section className="relative bg-brand-beige-light overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-20 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-caprasimo mb-4 sm:mb-6 text-brand-black px-4">
            Warum BR Webdesign?
          </h2>
          <p className="text-lg sm:text-xl text-brand-grey max-w-3xl mx-auto px-4">
            Webdesign & AI Solutions, die wirklich Ergebnisse liefern
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative bg-white rounded-2xl p-6 sm:p-8 overflow-hidden group hover:shadow-2xl transition-shadow"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-brand-beige-light rounded-xl mb-6 group-hover:bg-brand-green group-hover:scale-110 transition-all">
                <i className={`${benefit.icon} text-2xl text-brand-green group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-xl font-caprasimo mb-4 text-brand-black group-hover:text-brand-green transition-colors">
                {benefit.title}
              </h3>
              <p className="text-brand-grey leading-relaxed text-sm">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}